(function () {
  if (!document.body.classList.contains('template-product')) return;

  function initAccordions() {
    var sections = document.querySelectorAll(
      '.expandable-content--expandable'
    );

    if (!sections.length) return;

    sections.forEach(function (contentDiv, index) {

      var btn = contentDiv.querySelector('.expandable-content__toggle');
      if (!btn) return;

      if (contentDiv.hasAttribute('data-polypet-accordion-ready')) return;
      contentDiv.setAttribute('data-polypet-accordion-ready', 'true');

      btn.setAttribute('type', 'button');

      if (!contentDiv.id) {
        contentDiv.id = 'polypet-accordion-' + index;
      }

      btn.setAttribute('aria-controls', contentDiv.id);

      var currentState = contentDiv.getAttribute('aria-expanded') || 'false';
      btn.setAttribute('aria-expanded', currentState);
      contentDiv.setAttribute('data-expanded', currentState);

      // Phase 2 — remove aria-expanded from div
      contentDiv.removeAttribute('aria-expanded');

      // Capture-phase click — temporarily restore aria-expanded
      // before theme.min.js runs so it can read/write correctly
      btn.addEventListener('click', function () {
        var currentDataState = contentDiv.getAttribute('data-expanded') || 'false';
        contentDiv.setAttribute('aria-expanded', currentDataState);
      }, true);

      // MutationObserver — watch only aria-expanded
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'aria-expanded') {
            var newState = contentDiv.getAttribute('aria-expanded');

            // Ignore null — means we just removed it ourselves
            if (newState === null) return;

            // Only sync real true/false from theme.min.js
            if (newState === 'true' || newState === 'false') {
              btn.setAttribute('aria-expanded', newState);
              contentDiv.setAttribute('data-expanded', newState);

              // Remove aria-expanded from div after syncing
              requestAnimationFrame(function () {
                contentDiv.removeAttribute('aria-expanded');
              });
            }
          }
        });
      });

      observer.observe(contentDiv, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }

})();